import script from "./ListCompanies.vue?vue&type=script&setup=true&lang=js"
export * from "./ListCompanies.vue?vue&type=script&setup=true&lang=js"

import "./ListCompanies.vue?vue&type=style&index=0&id=0a3e15b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a3e15b4"]])

export default __exports__